import './QuestionnaireWarningOffcanvas.scss';

import { Offcanvas } from 'react-bootstrap';
import { Button } from '@myome/ui';

import { GC_LANGUAGE, MYOME_URL } from '@constants/constants';

type Props = {
  show: boolean;
  onHide: () => void;
  onProceed: () => void;
};

export default function QuestionnaireWarningOffcanvas({ show, onHide, onProceed }: Props) {
  return (
    <Offcanvas show={show} placement='top' onHide={onHide} className='questionnaire-warning-offcanvas'>
      <Offcanvas.Header closeButton aria-label='Close warning'></Offcanvas.Header>
      <Offcanvas.Body>
        <div className='questionnaire-warning-offcanvas__title'>
          Special considerations given your personal and family history
        </div>
        <div className='questionnaire-warning-offcanvas__body'>
          {GC_LANGUAGE.map((gc, i) => (
            <div key={i} className='questionnaire-warning-offcanvas__paragraph'>
              {gc}
            </div>
          ))}
        </div>
        <div className='questionnaire-warning-offcanvas__actions mt-3 gap-3'>
          <Button
            variant='danger-outline'
            onClick={() => {
              onHide();
              window.location.href = MYOME_URL;
            }}
          >
            Cancel Order
          </Button>
          <Button variant='primary' dataTestId='proceedAnyway' onClick={onProceed}>
            Proceed Anyway
          </Button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
